import { render, staticRenderFns } from "./ModelosVehiculos.vue?vue&type=template&id=265f2680&"
import script from "./ModelosVehiculos.vue?vue&type=script&lang=js&"
export * from "./ModelosVehiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports